/* eslint-disable @typescript-eslint/no-this-alias */

import classnames from 'classnames';
import React, { Component } from 'react';

import { Menu } from '@vimeo/iris/layout';

import { withVersion } from 'src/_tools/withVersion';

import styles from '../Navigations.module.scss';

export default class SideMenuNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      apiReference: [],
      changelog: [],
      isMobile: false,
      isSticky: false,
    };

    this.getMainSideMenu = this.getMainSideMenu.bind(this);
    this.applyStickyNav = this.applyStickyNav.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.setState({
      apiReference: devsite?.reference?.groups,
      changelog: this.props.page === 'changelog' ? devsite?.changelog : [],
    });

    if (this.state.width < 768 && this.props.page !== 'top-nav') {
      this.setState({ isMobile: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  applyStickyNav() {
    switch (this.props.page) {
      case 'create_app':
      case 'single_app':
        return true;
      default:
        return false;
    }
  }

  render() {
    if (this.state.isMobile) {
      return <div />;
    }

    const sideNavClass = classnames(styles.nav_wrapper, styles.top_padding, styles.right_divider);

    return (
      <nav
        id="nav_wrapper"
        className={this.applyStickyNav() ? [styles.sticky_side_nav] : [sideNavClass]}
      >
        <div className={styles.main_nav}>{this.getMainSideMenu()}</div>
      </nav>
    );
  }

  /**
   * Returns the parent menu items
   * @returns {Object}
   */
  getMainSideMenu() {
    const app = window.devsite?.app;
    switch (this.props.page) {
      case 'single_app':
        return (
          <div id="single_app_nav" className={styles.single_app}>
            <Menu>
              <Menu.Section>
                <Menu.Item href={`/apps/${app?.id}#general_info`}>General information</Menu.Item>
                <Menu.Item href={`/apps/${app?.id}#permissions`}>Permissions</Menu.Item>
                <Menu.Item href={`/apps/${app?.id}#authentication`}>Authentication</Menu.Item>
                <div style={{ paddingLeft: '2rem' }}>
                  <Menu.Item href={`/apps/${app?.id}#generate_access_token`}>
                    Generate Access Token
                  </Menu.Item>

                  <Menu.Item href={`/apps/${app?.id}#personal_access_tokens`}>
                    Personal Access Tokens
                  </Menu.Item>
                  <Menu.Item href={`/apps/${app?.id}#manage_app_secrets`}>
                    Manage App Secrets
                  </Menu.Item>
                  <Menu.Item href={`/apps/${app?.id}#oauth_redirect_auth`}>
                    OAuth Redirect Authentication
                  </Menu.Item>
                </div>
                <Menu.Item href={`/apps/${app?.id}/webhooks`}>Webhooks</Menu.Item>
              </Menu.Section>
            </Menu>
          </div>
        );

      default:
        let self = this;
        let menus = Object.keys(devsite?.side_nav).map(function (page, i) {
          const pageConfig = devsite.side_nav[page];

          if (
            (page === 'api-reference' && typeof devsite?.reference !== 'undefined') ||
            typeof pageConfig.subnav !== 'undefined'
          ) {
            let subnav;
            let subnavItemActive = false;
            if (page === 'api-reference' && typeof devsite?.reference !== 'undefined') {
              subnav = self.getReferenceDocsSubMenu();

              // Instead of trying to actually determine what reference docs group the user is
              // looking at, assume that since we have a subpage prop they're seeing real docs
              // and not a 404, and we can make the "API Reference" link non-active.
              if (self.props.subpage) {
                subnavItemActive = true;
              }
            } else {
              subnav = [];
              Object.keys(pageConfig.subnav).map(function (subpage, ii) {
                const item = pageConfig.subnav[subpage];
                if (!subnavItemActive && self.props.subpage === subpage) {
                  subnavItemActive = true;
                }

                subnav.push(
                  <Menu.Item
                    active={self.props.subpage === subpage}
                    href={item.link}
                    key={`nav-${page}-subnav-${ii + 1}`}
                  >
                    {item.name}
                  </Menu.Item>,
                );
              });
            }

            return (
              <Menu.Item
                key={`nav-${i}`}
                toggle
                active={!subnavItemActive && self.props.page === page}
                labelId={pageConfig.name.toLowerCase().replace(' ', '_') + '_menu'}
              >
                {pageConfig.link === '/api/reference' && (
                  <Menu.Item href={pageConfig.link} key={`nav-${i}-overview`}>
                    Overview
                  </Menu.Item>
                )}
                {pageConfig.name}
                {subnav.map((item) => item)}
              </Menu.Item>
            );
          }

          return (
            <Menu.Item
              key={`nav-${i}`}
              active={self.props.page === page}
              href={
                pageConfig.link === '/api/reference'
                  ? withVersion(pageConfig.link)
                  : pageConfig.link
              }
            >
              {pageConfig.name}
            </Menu.Item>
          );
        });

        return <Menu>{menus}</Menu>;
    }
  }

  /**
   * Returns the sub menu items for each API documentation group.
   * @returns {Array}
   */
  getReferenceDocsSubMenu() {
    let menu = [];
    let self = this;

    Object.keys(this.state.apiReference).map(function (groupSlug, i) {
      let groupItem = self.state.apiReference[groupSlug];
      let subgroups = Object.keys(groupItem.subgroups);
      let subMenu = [];
      let groupUrl = withVersion('/api/reference/' + groupSlug);

      let subgroupItemActive = false;

      if (!subgroupItemActive && self.props.subpage === groupSlug) {
        subgroupItemActive = true;
      }

      if (subgroups.length === 0) {
        menu.push(
          <Menu.Item
            className={styles.sidenav_resource_no_sub_group}
            key={`ref-docs-nav-${i}`}
            active={self.props.subpage === groupSlug}
            href={groupUrl}
          >
            {groupItem.label}
          </Menu.Item>,
        );
      } else {
        subgroups.map(function (subgroupSlug, ii) {
          let subgroupItem = groupItem.subgroups[subgroupSlug];
          let subgroupUrl = groupUrl + '#' + subgroupSlug;

          subMenu.push(
            <Menu.Item href={subgroupUrl} key={`ref-docs-nav-${i}-${ii}`}>
              {subgroupItem.label}
            </Menu.Item>,
          );
        });

        menu.push(
          <div style={{ paddingLeft: '20px', background: 'unset' }} key={`ref-docs-nav-${i}`}>
            <Menu.Item
              key={`ref-docs-nav-${i}`}
              active={window.location.pathname === '/api/reference/' + groupSlug}
              subMenuItems={subMenu}
              toggle
            >
              {groupItem.label}
              <Menu.Item href={groupUrl}>Overview</Menu.Item>
              {subMenu}
            </Menu.Item>
          </div>,
        );
      }
    });

    return menu;
  }
}
